export var K_LINKING_TEXT_UNDERLINEABLE_DATASET={underlineonhover:'true'};